// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper___1KTM4"};